<script>
import HeaderTabsContent from '@/views/Layouts/HeaderTabsContent'
import StudentSvg from '@/assets/student.svg'

export default {
  extends: HeaderTabsContent,
  computed: {
    title() {
      return 'Biblioteka'
    },
    routes() {
      return [
        {
          label: 'Kursy',
          icon: 'laptop',
          to: `/admin/biblioteka/kursy`
        },
        {
          label: 'Dla lektorów',
          icon: 'user',
          to: `/admin/biblioteka/lektorzy`
        },
        {
          label: 'Dla kursantów',
          iconComponent: StudentSvg,
          to: `/admin/biblioteka/kursanci`
        }
      ]
    }
  }
}
</script>
